const AboutMe = () => {
  return (
    <section id="about-me">
      {/* <div className="about-me__header">About me</div> */}
      <div className="row">
        <div className="row justify-content-center">
          <div
            data-aos="zoom-in"
            data-aos-delay="50"
            data-aos-duration="1000"
            className="col-sm-12 col-md-3 col-lg-12"
          >
            <p className="about-me__description">
              I love building products from the ground up and enjoy the entire
              journey — from ideation to bringing ideas to life for real users.
              With over 8 years of experience in software development, combined
              with a background in product management and UI/UX design, I have
              hands-on expertise across the full development lifecycle. I’m
              skilled in turning concepts into intuitive interfaces, crafting
              reusable components, architecting secure APIs, managing databases,
              and deploying applications to the cloud. My work is driven by
              modern technologies, clean code, high performance, and strong
              collaboration.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutMe;
